import { useAssetReportStore } from '../../domain/assetReport/store/AssetReport.localforage';
import { useMemo } from 'react';
import { LOCALFORAGE_YN } from '../comstant/CommonConstants';
import { useAssetGoalsStore } from '../../domain/assetGoals/stroe/AssetGoals.store';
import { useAssetPortfolioStore } from '../../domain/assetPortfolio/store/AssetPortfolio.store';
import { useApartmentCompareStore } from '../../domain/apartmentCompare/store/ApartmentCompare.store';
import fileDownload from 'js-file-download';
import { useInvestmentIncomeStore } from '../../domain/investmentIncome/store/InvestmentIncome.localforage';

export const useCommonStore = () => {
  const { assetReportStore, exportAssetReportStore, importAssetReportStore, clearAssetReportStore } =
    useAssetReportStore();

  const { exportAssetGoalsStore, importAssetGoalsStore, clearAssetGoalsStore } = useAssetGoalsStore();

  const { exportAssetPortfolioStore, importAssetPortfolioStore, clearAssetPortfolioStore } =
    useAssetPortfolioStore();

  const {
    exportApartmentCompareStore,
    importApartmentCompareStore,
    clearApartmentCompareStore,
  } = useApartmentCompareStore();

  const {
    exportInvestmentIncomeStore,
    importInvestmentIncomeStore,
    clearInvestmentIncomeStore,
  } = useInvestmentIncomeStore();

  const isReady = useMemo(() => {
    if (!LOCALFORAGE_YN) return true;
    return assetReportStore !== undefined;
  }, [assetReportStore]);

  const importStoreData = async (file: File) => {
    const text = await file.text();
    let entries;
    try {
      entries = JSON.parse(text);
    } catch (err) {
      throw new Error('파일이 올바른 JSON 형식이 아닙니다.');
    }
    await importAssetReportStore(entries['assetReportStoreData']);
    await importAssetGoalsStore(entries['assetGoalsStoreData']);
    await importAssetPortfolioStore(entries['assetPortfolioStoreData']);
    if (entries['apartmentCompareStoreData']) {
      await importApartmentCompareStore(entries['apartmentCompareStoreData']);
    }
    await importInvestmentIncomeStore(entries['investmentIncomeStoreData'] || []);
  };

  const exportStoreData = async () => {
    const assetReportStoreData = await exportAssetReportStore();
    const assetPortfolioStoreData = await exportAssetPortfolioStore();
    const assetGoalsStoreData = await exportAssetGoalsStore();
    const apartmentCompareStoreData = await exportApartmentCompareStore();
    const investmentIncomeStoreData = await exportInvestmentIncomeStore();
    const blob = new Blob(
      [
        JSON.stringify(
          {
            assetReportStoreData: assetReportStoreData,
            assetPortfolioStoreData: assetPortfolioStoreData,
            assetGoalsStoreData: assetGoalsStoreData,
            apartmentCompareStoreData: apartmentCompareStoreData,
            investmentIncomeStoreData: investmentIncomeStoreData,
          },
          null,
          2,
        ),
      ],
      {
        type: 'application/json',
      },
    );
    fileDownload(blob, 'backup.json');
  };

  const clearStoreData = async () => {
    await clearAssetReportStore();
    await clearAssetPortfolioStore();
    await clearAssetGoalsStore();
    await clearApartmentCompareStore();
    await clearInvestmentIncomeStore();
  };

  return {
    isReady,
    importStoreData,
    exportStoreData,
    clearStoreData,
  };
};
